import React from "react";

export const DashboardFootball = () => {
    return (
        <div>-</div>
    );
};